module.exports = __webpack_public_path__ + "ca282599a9fca1abb5d8ecb0a56cecb6.MP3";